import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function PromotionCodesAPI() {
    const basePromoCodesAPI = "promotion-codes";

    const listPromotionCodes = async (
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null,
        couponId
    ) => {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            const URL = `${API_VERSIONS.v1}/${basePromoCodesAPI}/list/${couponId}?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const createPromotionCodes = async (payload) => {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const sharePromotionCode = async (payload) => {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}/share`,
                payload
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    };

    const exportPromotionCodes = async (payload) => {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}/export`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const deletePromotionCodes = async (id) => {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const deleteBulkPromotionCodes = async (ids) => {
        try {
            const result = await RequestHandler.remove(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}`,
                ids
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const getPromotionCodeOffer = async (payload) => {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${basePromoCodesAPI}/offer`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    return {
        listPromotionCodes,
        createPromotionCodes,
        sharePromotionCode,
        exportPromotionCodes,
        deletePromotionCodes,
        deleteBulkPromotionCodes,
        getPromotionCodeOffer,
    };
}

export default PromotionCodesAPI();
